import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogClose, MatDialogTitle } from '@angular/material/dialog';
import { HandsetService } from '../../../core/services/handset.service';
import { CustomerBiller } from '../../models/model';
import { CustomerBillerStoreService } from '../../services/customer-biller-store.service';
import {
  DefaultClassDirective,
  DefaultFlexDirective,
  DefaultLayoutAlignDirective,
  DefaultLayoutDirective, DefaultShowHideDirective,
} from 'ng-flex-layout';
import { MatButton } from '@angular/material/button';
import { IconComponent } from '../../../shared/components/icon/icon.component';

@Component({
  standalone: true,
  selector: 'app-xsell-consent-dialog',
  styleUrls: ['./xsell-consent-dialog.component.scss'],
  templateUrl: './xsell-consent-dialog.component.html',
  imports: [
    DefaultClassDirective,
    MatDialogTitle,
    DefaultLayoutDirective,
    DefaultLayoutAlignDirective,
    DefaultFlexDirective,
    MatButton,
    MatDialogActions,
    MatDialogClose,
    DefaultShowHideDirective,
    IconComponent,
  ],
})
export class XsellConsentDialogComponent {
  // public config: SwiperConfigInterface = {
  //   direction: 'horizontal',
  //   navigation: {
  //     nextEl: '.swiper-button-next',
  //     prevEl: '.swiper-button-prev',
  //   },
  //   pagination: {
  //     el: '.swiper-pagination',
  //   },
  // };

  constructor(
    @Inject(MAT_DIALOG_DATA) public customerBiller: CustomerBiller,
    public handsetService: HandsetService,
    private customerBillerStoreService: CustomerBillerStoreService,
  ) {}

  public accept(): void {
    this.customerBillerStoreService.acceptXsellOfferConsent(this.customerBiller.id).subscribe();
  }
}
